// extracted by mini-css-extract-plugin
module.exports = {"allotmentContainer":"styles_allotmentContainer__5WJUk"};